import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import LoadingPage from '../components/LoadingPage';
import { useSetting } from '../../util/useSetting.js';
import { fetchUserDataById } from '../../services2/users.service.js';
import CATEGORIESSVG from '../../svg/teacher/Categories.js'


const LAST_MISSION = {
  name: '天下襟懷',
  subtitle: '范仲淹〈岳陽樓記〉｜歐陽修〈醉翁亭記〉',
  progress: 0.2,
  CATEGORIES: ['文化傳統', '作者處境'],
  image: '/secondary/tasks/1.png'
}
const OTHER_TASKS = [
  {
    name: '托物言志',
    image: '/secondary/tasks/2.png'
  },
  {
    name: '孔孟之道',
    image: '/secondary/tasks/3.png'
  },
  {
    name: '天下襟懷',
    image: '/secondary/tasks/4.png'
  },
]
const TEACHER_MATERIALS = [
  {
    type: '模型視頻',
    name: '單元概念與閱讀觀念',
    image: '/secondary/tasks/5.png'
  },
  {
    type: '教育局文件',
    name: '數字閱讀與文本連結',
    image: '/secondary/tasks/6.png'
  },
  {
    type: '平台入門',
    name: '平台快速入門',
    image: '/secondary/tasks/7.png'
  },
]
const RESEARCHES = [
  { 
    id: '1',
    name: '香港學生睡眠',
    image: '/secondary/tasks/8.png',
    subtitle: '研究測試 1'
  },
  {
    id: '2',
    name: '機器人',
    image: '/secondary/tasks/9.png',
    subtitle: '研究測試 2'
  },
]
const CATEGORIES = [
  { id: '歷史背景' },
  { id: '文化傳統' },
  { id: '文學賞讀' },
  { id: '作者處境' },
  { id: '讀者回應' },
  { id: "文本特色" }
]
function Component(props) {
  const navigate = useNavigate();
  const { fontSize } = useSetting();
  const [data, setdata] = useState(null)
  const [isLoading, setisLoading] = useState(false)

  const [user, setuser] = useState(null)
  async function fetchData() {
    let result = await fetchUserDataById(props.token.token)
    if (result.result) {
      setuser(result.result)

    }
  }
  useEffect(() => {
    fetchData();
  }, [])

  const [selectedCategory, setselectedCategory] = useState(null)
  const handleToggleCategory = (categoryId) => {
    if (categoryId === selectedCategory) {
      setselectedCategory(null);
    } else {
      setselectedCategory(categoryId);
    }
  };



  return (
    <div className='h-full flex-1 bg-[#EDF5F8] p-[16px] flex flex-col gap-[16px] overflow-auto' style={{ fontSize, backgroundImage: 'url(/secondary/bg.png)', backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center' }}>

      <div style={{ color: '#4B555C', fontSize: fontSize, fontWeight: '900' }}>歡迎回來, {user ? user.name : ''} [{user ? user.username : ''}]</div>
      <div className='relative flex flex-col items-start'>
        <img src='/secondary/title.png' alt='' style={{ height: '102px', objectFit: 'contain' }} />
      </div>
      <div className='w-full flex flex-row gap-[16px] flex-wrap'>
        <div className='flex flex-col gap-[16px] justify-center relative pt-[42px]'>
          
          <div className='text-[#003A57] font-bold'>歷史、文化、文學</div>
          <div className='flex flex-row gap-[8px]'>
            <button
              className='px-[16px] rounded-full py-[4px] font-bold'
              style={(!selectedCategory) || (selectedCategory === CATEGORIES[0].id) ? { background: 'linear-gradient(to right, #003A57, #108B96)', color: 'white' } : { color: '#6B6E70', background: 'linear-gradient(to right, #BEBEBE90, #fff)' }}
              onClick={() => handleToggleCategory(CATEGORIES[0].id)}>
              {CATEGORIES[0].id}
            </button>
            <button
              className='px-[16px] rounded-full py-[4px] font-bold'
              style={(!selectedCategory) || (selectedCategory === CATEGORIES[1].id) ? { background: 'linear-gradient(to right, #003A57, #108B96)', color: 'white' } : { color: '#6B6E70', background: 'linear-gradient(to right, #BEBEBE90, #fff)' }}
              onClick={() => handleToggleCategory(CATEGORIES[1].id)}>
              {CATEGORIES[1].id}
            </button>
            <button
              className='px-[16px] rounded-full py-[4px] font-bold'
              style={(!selectedCategory) || (selectedCategory === CATEGORIES[2].id) ? { background: 'linear-gradient(to right, #003A57, #108B96)', color: 'white' } : { color: '#6B6E70', background: 'linear-gradient(to right, #BEBEBE90, #fff)' }}
              onClick={() => handleToggleCategory(CATEGORIES[2].id)}>
              {CATEGORIES[2].id}
            </button>
          </div>
          <div className='text-[#003A57] font-bold'>作者、讀者、文本</div>
          <div className='flex flex-row gap-[8px]'>
            <button
              className='px-[16px] rounded-full py-[4px] font-bold'
              style={(!selectedCategory) || (selectedCategory === CATEGORIES[3].id) ? { background: 'white', color: '#108B96' } : { color: '#6B6E70', background: 'linear-gradient(to right, #BEBEBE90, #fff)' }}
              onClick={() => handleToggleCategory(CATEGORIES[3].id)}>
              {CATEGORIES[3].id}
            </button>
            <button
              className='px-[16px] rounded-full py-[4px] font-bold'
              style={(!selectedCategory) || (selectedCategory === CATEGORIES[4].id) ? { background: 'white', color: '#108B96' } : { color: '#6B6E70', background: 'linear-gradient(to right, #BEBEBE90, #fff)' }}
              onClick={() => handleToggleCategory(CATEGORIES[4].id)}>
              {CATEGORIES[4].id}
            </button>
            <button
              className='px-[16px] rounded-full py-[4px] font-bold'
              style={(!selectedCategory) || (selectedCategory === CATEGORIES[5].id) ? { background: 'white', color: '#108B96' } : { color: '#6B6E70', background: 'linear-gradient(to right, #BEBEBE90, #fff)' }}
              onClick={() => handleToggleCategory(CATEGORIES[5].id)}>
              {CATEGORIES[5].id}
            </button>
          </div>
          <div className=''>
            {selectedCategory ? <button className='flex flex-row items-center gap-[4px] text-[#A9FFDC] px-[16px]  py-[4px] rounded-full bg-[#009191] font-bold h-[38px]' onClick={() => { setselectedCategory(null) }}>
              <img src='/secondary/reset.png' alt='' style={{ height: '16px', objectFit: 'contain' }} />
              重設
            </button> :
              <div className='h-[38px]'></div>}
          </div>
        </div>

        <CATEGORIESSVG handleToggleCategory={handleToggleCategory} selectedCategory={selectedCategory} />
        <div className='flex flex-col justify-center flex-1'>
          <div className='text-[#003A57] font-bold min-h-[200px] p-[16px] w-[100%] max-w-[600px] min-w-[200px]' style={{ border: '2px solid white', borderRadius: '8px' }}>
            課程目標
          </div>
        </div>
      </div>

      <div className='w-full flex flex-row gap-[16px] flex-wrap text-[#003A57]' >
        {/*last mission*/}
        <div className='relative flex-1 flex flex-col p-[16px] rounded-[16px] min-w-[400px] font-bold overflow-hidden' style={{ aspectRatio: '763/403', backgroundImage: `url(${LAST_MISSION.image})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
          <div className='absolute bottom-0 left-0 right-0 h-[50%] z-[1]' style={{ background: 'linear-gradient(to top, rgba(255,255,255,1), rgba(0,0,0,0))' }} />

          <div className='flex flex-row items-center justify-start gap-[16px] z-[2] font-[900]' style={{}}>
            互文閱讀
            <div className='bg-[#EE8D59] text-white px-[8px] py-[4px] flex flex-col rounded-full font-bold noto-san-hk' style={{ fontSize: fontSize - 4 }}>上次單元</div>
          </div>
          <div className='flex flex-col justify-end flex-1 z-[2]'>
            <div className='flex flex-row items-center justify-start gap-[16px] '>
              <div style={{ fontWeight: 'bold', fontSize: fontSize + 4 }}>{LAST_MISSION.name}</div>
              <div className='px-[16px] rounded-full py-[4px] font-bold' style={{ background: 'linear-gradient(to right, #003A57, #108B96)', color: 'white' }}>
                {CATEGORIES[1].id}
              </div>
              <div className='px-[16px] rounded-full py-[4px] font-bold' style={{ background: 'white', color: '#108B96' }}>
                {CATEGORIES[3].id}
              </div>
            </div>
            <div className='text-black mt-[8px]' style={{ fontWeight: 'bold' }}>{LAST_MISSION.subtitle}</div>
            <div className='flex flex-row w-full items-center text-[#005B8C] gap-[16px]'>
              進度
              <div className='w-[50%] relative rounded-full h-[8px] bg-gray-200 overflow-hidden'>
                <div className='absolute top-0 left-0 h-[8px] bg-[#178E95]' style={{ width: `${LAST_MISSION.progress * 100}%` }} />
              </div>
              {`${Math.round(LAST_MISSION.progress * 100)}%`}
              <div className='flex-1 flex flex-row justify-end'>
                <button className='text-[#007A83] font-bold mb-[6px] mr-[8px] noto-san-hk text-white p-[2px] rounded-full' style={{ fontSize: fontSize - 2, background: 'linear-gradient(to left, #015B6B, #00E9BA)' }}
                  onClick={()=>{navigate('/platform2/missions?id=6aaa333902c8bacb119a00a0')}}
                >
                    <div className='rounded-full px-[20px] py-[6px] ' style={{border:'2px solid #eee',background:'linear-gradient(to right, #015B6B, #00E9BA)'}}>
                      {'繼續單元 >'}
                    </div>
                  </button>
              </div>
            </div>
          </div>
        </div>
        <div className='flex-1 flex flex-col p-[16px] rounded-[16px] min-w-[400px] font-bold ' style={{ border: '2px solid white', aspectRatio: '763/403' }}>
          <div className='flex flex-row items-center justify-between font-[900]'>
            其他互文閱讀
            <button className='text-[#007A83] font-bold noto-san-hk' style={{ fontSize: fontSize - 2 }} onClick={() => { navigate('/platform2/missions') }}>
              {' 進入單元總覽  >'}
            </button>
          </div>
          <div className='w-full flex flex-row overflow-x-auto gap-[16px] justify-start items-stretch mt-[16px] flex-1'>
            {OTHER_TASKS.map((item) =>
              <div key={item} className='flex-1 min-w-[150px] max-w-[250px] bg-[#ffffff80] rounded-[8px] flex-shrink-0 flex flex-col overflow-hidden h-full' style={{ border: '2px solid white' }}>
                <img src={item.image} alt={item.name} className='w-full object-cover' />
                <div className='p-[8px] font-bold'>{item.name}</div>
                <div className='flex-1 flex flex-col items-end justify-end'>
                  <button className='text-[#007A83] font-bold mb-[6px] mr-[8px] noto-san-hk' style={{ fontSize: fontSize - 2 }}
                    onClick={()=>{alert('Coming Soon! (尚未開放)')}}
                  >
                    {'進入  >'}
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className='w-full flex flex-row gap-[16px] flex-wrap text-[#003A57]' >
        <div className='flex-1 flex flex-col p-[16px] rounded-[16px] min-w-[400px] font-bold ' style={{ border: '2px solid white', background: 'linear-gradient(to bottom, #ffffff90, #ffffff00)' }}>
          <div className='flex flex-row items-center justify-between'>
            教師專業發展
            <button className='text-[#007A83] font-bold noto-san-hk' style={{ fontSize: fontSize - 2 }} onClick={()=>{navigate('/platform2/teacher-resources')}}>
              {'全部學習資料  >'}
            </button>
          </div>
          <div className='w-full flex flex-row overflow-x-auto gap-[16px] justify-start items-stretch mt-[16px] flex-1'>
            {TEACHER_MATERIALS.map((item) =>
              <div key={item} className='flex-1 min-w-[150px] max-w-[250px] flex-shrink-0 flex flex-col h-full pb-[8px]'>
                <div className='p-[8px] font-bold text-black noto-san-hk' style={{ fontSize: fontSize - 4 }}>{item.type}</div>
                <div className='flex-1 w-full flex flex-col bg-[#ffffff80] rounded-[8px]' style={{ border: '2px solid white', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)' }}>
                  <img src={item.image} alt={item.name} className='w-full object-cover' />
                  <div className='p-[8px] font-bold'>{item.name}</div>
                  <div className='flex-1 flex flex-col items-start justify-end pl-[8px] mb-[6px]'>
                    <button className='text-[#007A83] font-bold px-[16px] py-[4px] rounded-full text-[#fff] noto-san-hk' style={{ fontSize: fontSize - 4, background: 'linear-gradient(to right, #34778C, #63BBD1)' }}
                      onClick={()=>{alert('Coming Soon! (尚未開放)')}}
                    >
                      {'開啟資源 >'}
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className='flex-1 flex flex-col p-[16px] rounded-[16px] min-w-[400px] font-bold ' style={{ border: '2px solid white' }}>
          <div className='flex flex-row items-center justify-between'>
            研究測試
            <button className='text-[#007A83] font-bold noto-san-hk' style={{ fontSize: fontSize - 2 }} onClick={() => navigate('/platform2/research-practices')}>
              {' 全部研究測試  >'}
            </button>
          </div>
          <div className='w-full flex flex-row overflow-x-auto gap-[16px] justify-start items-stretch mt-[16px] flex-1'>
            {RESEARCHES.map((item) =>
              <div key={item} className='flex-1 min-w-[150px] max-w-[280px] bg-[#ffffff80] rounded-[8px] flex flex-col overflow-hidden h-full' style={{ border: '2px solid white' }}>
                <img src={item.image} alt={item.name} className='w-full object-cover' />
                <div className='px-[8px] font-bold my-[4px]'>{item.name}</div>
                <div className='px-[8px] text-[black] noto-san-hk' style={{ fontSize: fontSize - 4 }}>{item.subtitle}</div>
                <div className='flex-1 flex flex-col items-end justify-end'>
                  <button onClick={() => navigate(`/platform2/research-practices/preview/${item.id}`)} className='text-[#007A83] font-bold mb-[6px] mr-[8px] noto-san-hk text-white p-[2px] rounded-full' style={{ fontSize: fontSize - 2, background: 'linear-gradient(to left, #015B6B, #00E9BA)' }}>
                    <div className='rounded-full px-[20px] py-[6px] ' style={{border:'2px solid #eee',background:'linear-gradient(to right, #015B6B, #00E9BA)'}}>
                      {'開始測試 >'}
                    </div>
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>

      </div>


      {isLoading && <LoadingPage />}
    </div>
  );
}

export default connect((store) => {
  return {
    token: store.tokenReducer,
  }
})(Component)
